import { koComponent } from '../../ko-utils';
import $api from '../../api';
import { UserModel } from '../../models/Gen/BaseModels';

class UsersView {
    constructor(params) {
        this.users = ko.observableArray();

        this.load();

        //this.roles = [
        //    { name: 'Owner', value: 0 },
        //    { name: 'Editor', value: 1 }
        //];
    }

    load() {
        $api.projects.getAssignedUsers(
            {
                projectCode: auth.project.UniqueCode
            },
            {},
            (resp) => {
                for (var user of resp) {
                    this.users.push(new UserModel(user));
                }
            }
        );
    }

    removeUser() {
        console.log('removing');
    }
}

export default koComponent('project-users-view', UsersView);